export default class MouseHover {

    constructor() {
		this.mouseFollower = document.getElementById('mouse-follower')
		this.innerSliderCursors = document.querySelectorAll('[data-mouse-follower*="animation-cursor"], [data-mouse-follower*="explore-cursor"]')

		this.events()
	}

	onMouseHover(e) {
		this.mouseFollower.classList.add('mouse-follower-drag')
	}
	onMouseOut(e) {
		this.mouseFollower.classList.remove('mouse-follower-drag')
	}

	events() {
		this.innerSliderCursors.forEach( innerSliderCursor => {
			innerSliderCursor.addEventListener( 'mouseover', this.onMouseHover.bind(this), false)
			innerSliderCursor.addEventListener( 'mouseout', this.onMouseOut.bind(this), false)
		})
	}

}

/**
 * Mouse Follower Interactions
 */

let mouseX = 0;
let mouseY = 0;

let ballX = 0;
let ballY = 0;

let speed = 0.1;

let mouseFollower = document.getElementById('mouse-follower')

const mouseFollowerFunc = function mouseFollowerFunc() {

	let distX = mouseX - ballX;
	let distY = mouseY - ballY;

	ballX = ballX + (distX * speed);
	ballY = ballY + (distY * speed);

	mouseFollower.style.left = ballX + 'px';
	mouseFollower.style.top = ballY + 'px';

	requestAnimationFrame(mouseFollowerFunc);
}

mouseFollowerFunc();

document.addEventListener('mousemove', function(event){
	mouseX = event.clientX;
	mouseY = event.clientY;
});
